import React from "react";

/**
 * Pathogen names use bare `*` to delimit italic ranges (e.g. "Genus *species*").
 * Even-index segments render plain, odd-index segments render italic.
 * Escape with `\*` to render a literal asterisk.
 */
export function Pathogen({ name }: { name: string | null | undefined }) {
  if (!name) return null;
  const chunks = name.split(/(?<!\\)\*/);
  return (
    <span>
      {chunks.map((c, i) => (
        <span key={i} className={i % 2 === 1 ? "italic" : ""}>
          {c.replace(/\\\*/g, "*")}
          {i < chunks.length - 1 && i % 2 === 0 ? "" : null}
        </span>
      ))}
    </span>
  );
}

export function formatCopies(n: number | null | undefined): string {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toLocaleString();
}
